/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react'
import { useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'

import { QUERY_KEYS } from '../../api'
import { ROUTE_KEYS } from '../../constants'
import { useGeneral, useUser } from '../../contexts'
import { BlockTrainStatusEnum, Filters } from '../../types'
import BlocktrainApi from './api'

interface UseBlocktrainsProps {
  filters?: Filters
}

interface ExtendedFilters extends Filters {
  blocktrainId?: string
}

const useBlocktrains = ({ filters }: UseBlocktrainsProps) => {
  const { ticketToSearch } = useGeneral()
  const { state: user } = useUser()
  const navigate = useNavigate()
  const { data: blocktrains, isLoading: blocktrainsIsLoading } = useQuery(
    [QUERY_KEYS.BLOCKTRAINS, filters, ticketToSearch],
    () =>
      BlocktrainApi.getAllByFilters({
        filters: ticketToSearch ? ({ blocktrainId: ticketToSearch } as ExtendedFilters) : filters,
      }),
    {
      staleTime: 0,
    },
  )

  useEffect(() => {
    if (!user) {
      console.error('User is undefined')
      return
    }
    const userRole = user.roles[0]?.name as 'SUPPLIER' | 'ADMIN' | 'ADMINRO'
    if (blocktrains?.blockTrains?.length === 1 && ticketToSearch) {
      if (blocktrains.blockTrains[0].status === BlockTrainStatusEnum.FINISHED) {
        navigate(ROUTE_KEYS[userRole].HISTORIC)
      } else {
        navigate(ROUTE_KEYS[userRole].BLOCKTRAINS)
      }
    }
  }, [blocktrains])

  return {
    blocktrains,
    blocktrainsIsLoading,
  }
}

export default useBlocktrains
